module.exports = __webpack_public_path__ + "static/media/entidad-publica.42fa2c02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empresa/entidad-publica.svg
// module id = 159
// module chunks = 0